/* eslint-disable complexity */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import * as EmailValidator from "email-validator";
import { useCart, useGlobalState } from '~/context';
import { ButtonWithArrow, Title } from '~/ui';
import type { ForgotPasswordSchemaInput } from '~/validation';
import { forgotPasswordSchema } from '~/validation';

export const ForgotPassword = () => {
  const { abortController } = useCart();
  const [authErrorMessage, setAuthErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [result, setResult] = useState(null);
  const [validationResult, setValidationResult] = useState<any>(null);
  const [emailBlurred, setEmailBlurred] = useState(false);
   const { openFullScreenModal,closeFullScreenModal } = useGlobalState()
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, touchedFields, dirtyFields },
    setValue,
    reset
  } = useForm<ForgotPasswordSchemaInput>({
    resolver: zodResolver(forgotPasswordSchema),
    mode: 'all'
  });
  useEffect(() => {
    if (
      validationResult?.message === "Domain does not exist." ||
      validationResult?.message === "Internal server error."
    ) {
      //alert(JSON.stringify(validationResult))
      setIsValidEmail(false);
    }
    //alert(validationResult?.message)
  }, [validationResult]);
  const containsErrorsEmail = Object.keys(errors).includes('email');

  const emailValidation =
    !containsErrorsEmail && dirtyFields.email
      ? 'primary-input-isValid'
      : touchedFields.email && 'primary-input-isInvalid';

  async function onSubmitForm(values: ForgotPasswordSchemaInput) {
    try {
      if (authErrorMessage) {
        setAuthErrorMessage('');
      }

      openFullScreenModal()
      const responseOptions = {
        method: 'POST',
        body: JSON.stringify({
          username: values.email
        }),
        signal: abortController?.signal,
        headers: {
          'Content-Type': 'application/json'
        }
      };
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/auth/forgot-password`,
        responseOptions
      );
      const data = await response.json();
      if (data.data.sendPasswordResetEmail) {
        closeFullScreenModal()
        // toast.success('Registered!')
        reset();
        setSuccessMessage('Success! Check your email for a link to reset your password.');
      } else {
        closeFullScreenModal()
        throw new Error(data.errors?.[0].message);
      }
    } catch (error) {
      closeFullScreenModal()
      setSuccessMessage('');
      if (error instanceof Error) {
        if (error.message.includes('There is no user registered with that email address')) {
          return setAuthErrorMessage(error.message);
        }
        // toast.error(error.message)
      }
      
      setAuthErrorMessage('Something went wrong');
    }
    closeFullScreenModal()

  }

  function getRestPartAfterFirstDot(domain:any) {
    const parts = domain.split(".");
    return parts.slice(1).join(".");
  }
  const verifyTLD = async (email1:any) => {
    try {
      const domain1 = email1.split("@")[1];
      // const domain2 = domain1.split(".")[2];
      const domain2 = getRestPartAfterFirstDot(domain1);
      const response = await fetch(`/api/mandrill/verify-email?tld=${domain2}`);
      const data = await response.json();
      setResult(data.exists);
    } catch (error) {
      // console.error("Failed to verify TLD:", error);
    }
  };

  const handleValidateEmail = async (domain:any) => {
    try {
      const domain1 = domain.split("@")[1];
      const response = await fetch("/api/mandrill/verify-email-deep", {
        //const response = await fetch("/api/mandrill/verify-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ domain: domain1 }),
      });

      if (response.ok) {
        const data = await response.json();
        setValidationResult(data);
      } else {
        setValidationResult(null);
      }
    } catch (error) {
      // console.error("Error:", error);
      setValidationResult(null);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    setIsValidEmail(EmailValidator.validate(fieldValue));
    handleValidateEmail(fieldValue);
    setValue(fieldName as any, fieldValue as any);
    // setEmail(fieldValue);
    verifyTLD(fieldValue);
  };
  const handleInputBlur = () => {
    setEmailBlurred(true);
  };
  return (
    <section className="max-w-[440px]">
      <Title className="text-colorFourteen">Forgot Password</Title>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <div className="grid grid-cols-1 gap-3">
          <div className="my-4">
            <input
              type="email"
              name="email"
              // style={{
              //   boxShadow: "none",
              //   borderColor: "transparent",
              // }}
              className={`primary-input input-border ${emailValidation}`}
              placeholder="Email address"
              autoComplete="email"
              aria-label="Email address"
              //{...register("email")}
              onChange={handleInputChange}
              onBlur={handleInputBlur}
            />
            {/* <p className="p-0 text-colorThirteen">{containsErrorsEmail && errors.email?.message}</p> */}
            {(validationResult?.valid && isValidEmail) ||
            (result && isValidEmail) ? (
              <p className="p-0 text-colorThirteen">{errors.email?.message}</p>
            ) : (
              emailBlurred===true && <p className="p-0 text-colorThirteen">
                Please enter a valid email address.
              </p>
            )}
          </div>

          <div>
            <ButtonWithArrow buttonType="submit" buttonVariant="primary" disabled={(!validationResult?.valid && !isValidEmail) ||
            (!result && !isValidEmail)}>
              {isSubmitting ? 'Processing...' : 'Forgot Password'}
            </ButtonWithArrow>
          </div>
          {authErrorMessage && (
            <div>
              <p className="p-0 text-colorThirteen">{authErrorMessage}</p>
            </div>
          )}
          {successMessage && !authErrorMessage && (
            <div>
              <p className="p-0 text-colorTen">{successMessage}</p>
            </div>
          )}
        </div>
      </form>
    </section>
  );
};
